import { FC } from "react";
import styles from "../headerBtn.module.scss";

interface ISectionOptions {
  title: string;
}

const LostVacancyRoutestSection: FC<ISectionOptions> = ({ title }) => {
  return (
    <div>
      <span className={styles.delete__report_message}>{title}</span>
    </div>
  );
};

export default LostVacancyRoutestSection;
